import { Skeleton } from 'antd'
import type { TotalsProps } from '../types'

import { Card } from './card'

export function Totals({
  lcrTotal,
  luminxTotal,
  lcr_file,
  payment_files,
  isLoading,
  hasData
}: TotalsProps): JSX.Element {
  return (
    <div className='flex flex-col gap-4'>
      {isLoading ? (
        <Skeleton.Node style={{ width: 288, height: 138, marginBottom: 10, borderRadius: 16 }} />
      ) : (
        <Card
          title='LCR'
          value={lcrTotal}
          hasData={hasData}
          error={{
            showError: (lcrTotal ?? 0) < (luminxTotal ?? 0) || !lcr_file,
            value: (luminxTotal ?? 0) - (lcrTotal ?? 0)
          }}
          details={[
            {
              data: [
                {
                  title: 'LCR NET',
                  value: lcr_file?.net
                },
                {
                  title: 'LCR Voided',
                  value: lcr_file?.voided
                }
              ]
            }
          ]}
        />
      )}

      {isLoading ? (
        <Skeleton.Node style={{ width: 288, height: 98, borderRadius: 16 }} />
      ) : (
        <Card
          title='LuminX'
          value={luminxTotal}
          hasData={hasData}
          error={{
            showError: (lcrTotal ?? 0) > (luminxTotal ?? 0) || payment_files.length === 0,
            value: (lcrTotal ?? 0) - (luminxTotal ?? 0)
          }}
          details={[
            {
              data: payment_files.map(p => ({
                title: p.filename,
                value: p.file_total
              }))
            }
          ]}
        />
      )}
    </div>
  )
}
